<template>
    <console-layout width="100%" max-width="1400">

        <console-title>
            <span>구매후기</span>
        </console-title>

        <console-search @search="page=1; search(true)">
            <v-row class="mt-2">
                <v-col cols="12" sm="3" class="py-0">
                    <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" persistent-placeholder hide-details @input="filter.searchValue = null;" />
                </v-col>
                <v-col cols="12" sm="3" class="py-0">
                    <v-text-field v-model="filter.searchValue" label="검색어" persistent-placeholder hide-details clearable :disabled="!filter.searchKey" @keydown.enter="page = 1; search(true)" />
                </v-col>
            </v-row>
        </console-search>

        <console-body>
            <v-data-table :items="reviews" :headers="reviewsHeaders" hide-default-footer disable-sort disable-pagination class="elevation-1">
                <template #[`item.no`]="{item}">
                    <span>{{ (page - 1) * limit + +reviews.indexOf(item) + 1 }}</span>
                </template>
                <template #[`item.product`]="{item}">
                    <v-layout class="align-center">
                        <v-flex shrink><v-img :src="item?.product?.thumb" width="96" height="96" contain></v-img></v-flex>
                        <v-flex class="text-start">
                            <div class="mx-2 text-truncate"><b v-html="item?.product?.name"></b></div>
                        </v-flex>
                    </v-layout>
                </template>
                <template #[`item.member`]="{item}">
                    <div v-if="item.member">
                        <div>{{ item?.member?.name }}</div>
                        <div>{{ item?.member?.phone }}</div>
                        <div>{{ item?.member?.email }}</div>
                    </div>
                    <span v-else>탈퇴회원</span>
                </template>
                <template #[`item.rating`]="{item}">
                    <v-rating :value="item.rating" color="yellow darken-1" background-color="grey" dense size="16" length="5" />
                </template>
                <template #[`item.createdAt`]="{item}">
                    <span>{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
                </template>
                <template #[`item.actions`]="{item}">
                    <span>
                        <v-icon small @click="remove(item)">mdi-delete</v-icon>
                    </span>
                </template>
            </v-data-table>
    
            <v-pagination v-model="page" :length="pageCount" total-visible="11" class="mt-3" @input="search(true)"/>
        </console-body>


    </console-layout>
</template>

<script>
import api from "@/api";
import XLSX from "xlsx";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null
            },

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            summary: { totalCount: 0 },
            reviews: [],
            reviewsHeaders: [
                { text: "no", value: "no", align: "center", width: 100 },
                { text: "리뷰상품", value: "product", align: "center" },
                { text: "리뷰내용", value: "content", align: "center", width: 300 },
                { text: "리뷰점수", value: "rating", align: "center", width: 100 },
                { text: "작성자", value: "member", align: "center", width: 180 },
                { text: "작성일자", value: "createdAt", align: "center", width: 180 },
                ...(this.$hasScope(['root', 'admin']) ? [{ text: "actions", value: "actions", align: "center", width: 100 }] : []),
            ],

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "이름", value: "writer.name" },
                { text: "아이디", value: "writer.username" },
            ]
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        init(){
            this.search(false);
        },
        async search(routable = false){
            if(routable){
                this.$router.push({
                    query: { ...this.filter, page: this.page }
                });
            }

            let { summary, reviews } = await api.console.shop.reviews.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.reviews = reviews;
            this.summary = summary;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },
        async remove(review){
            if(confirm("리뷰를 삭제하시겠습니까?")){
                await api.console.shop.reviews.delete(review);
                alert("삭제되었습니다");
                this.search(false);
            }
        },
        // async excel(){
        //     let { reviews } = await api.console.center.reviews.gets({ headers: { limit: 0 }, params: this.filter });

        //     let rows = [];
        //     reviews.forEach(review => {
        //         rows.push({
        //             "no": review.no,
        //             "이름": review.name,
        //         });
        //     });

        //     let workbook = new XLSX.utils.book_new();
        //     let worksheet = XLSX.utils.json_to_sheet(rows);

        //     XLSX.utils.book_append_sheet(workbook, worksheet, "엑셀시트이름");
        //     XLSX.writeFile(workbook, "엑셀파일이름.xlsx");
        // }
    }
}
</script>